import { SkyButton, SkyMessageBar } from "@skypointcloud/skypoint-ui";
import { useLocation } from "wouter";
import { absolutePath } from "@/lib/routes";

/**
 * An address that matches no route. It says so plainly and offers one way back;
 * inventing a page title for an unknown path is how a 404 ends up looking like
 * a real screen that failed to load.
 *
 * Two of the three mount points are inside a nested router — `/connections/:id`
 * and the route table's fallback — where a bare `navigate("/")` resolves against
 * the section base and lands the reader back on the section they were lost in,
 * under its own header. `absolutePath` is safe in the nested and unnested mounts
 * alike, so one call site covers all three.
 */
export default function NotFoundPage() {
  const [, navigate] = useLocation();

  return (
    <SkyMessageBar
      intent="warning"
      layout="multiline"
      title="That page does not exist"
      message="The address you followed does not match anything in skyData. It may have been renamed."
      actions={
        <SkyButton
          appearance="secondary"
          onClick={() => navigate(absolutePath("/"))}
          testId="not-found-home"
        >
          Go to the start
        </SkyButton>
      }
      testId="not-found"
    />
  );
}
